"use strict"

function iota(n) {
  var result = new Array(n)
  for(var i=0; i<n; ++i) {
    result[i] = i
  }
  return result
}

module.exports = iota


//////////////////
// WEBPACK FOOTER
// ../node_modules/iota-array/iota.js
// module id = 61
// module chunks = 0